import React from 'react';
import MinimalDumbo from '../../../DeviationViews/Dumbo/EditorDumbo';
import { Props } from '../ThumbView';

const ImageThumbView: React.FC<Props> = (props: Props) => {
  /* In editor we make the background transparent to avoid overlapping with custom backgrounds */
  return (
    <MinimalDumbo
      useBackgroundColor={false}
      // force a mature 'hidden' thumb for editor thumbs
      // (other thumbs are handled with a blur on the server side)
      handleMatureOnClientside
      {...props}
    />
  );
};
ImageThumbView.displayName = 'ImageThumbView';

export default ImageThumbView;
